<div class="d-flex flex-column" *ngIf="currentForm() != null" style="gap: 16px;">
    
    <div class="d-flex flex-column ql-editor-custom" *ngFor="let section of currentForm()!.sections; let index = index">

        <ng-container *ngIf="formSectionMetadataState()[index].shown == true">                    
            <div [id]="'sec-view-'+section.id"></div>
            <div>
                <ng-container *ngIf="openedComponentSection()[index]!=null && openedDynFormSection()[index]!=null">

                    <ng-template #refComponent [cdkPortalOutlet]="openedComponentSection()[index]">
                    </ng-template>

                </ng-container>
            </div>

        </ng-container>
    

    </div>


</div>